export default "__VITE_ASSET__Dhl3p2Ww__"